import { render } from "./NetworkForm.vue?vue&type=template&id=80f047c2&ts=true"
import script from "./NetworkForm.vue?vue&type=script&lang=ts"
export * from "./NetworkForm.vue?vue&type=script&lang=ts"

import "./NetworkForm.vue?vue&type=style&index=0&id=80f047c2&lang=css"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/NetworkForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "80f047c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('80f047c2', __exports__)) {
    api.reload('80f047c2', __exports__)
  }
  
  module.hot.accept("./NetworkForm.vue?vue&type=template&id=80f047c2&ts=true", () => {
    api.rerender('80f047c2', render)
  })

}


export default __exports__